export default __webpack_public_path__ + "static/media/upgrade-to-t.29dc07a8.svg";